import { render, staticRenderFns } from "./Payruns.vue?vue&type=template&id=9734a20e"
import script from "./Payruns.vue?vue&type=script&lang=js"
export * from "./Payruns.vue?vue&type=script&lang=js"
import style0 from "./Payruns.vue?vue&type=style&index=0&id=9734a20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports